import { default as IndexDViMv2jZ4dMeta } from "@/src/pages-modules/home/Index.vue?macro=true";
import { default as MaterialMineve4zHWmyYUMeta } from "@/src/pages-modules/material-manage/MaterialMine.vue?macro=true";
import { default as MaterialListAa1mVeYpOUMeta } from "@/src/pages-modules/material-manage/MaterialList.vue?macro=true";
import { default as IndexZcHpkFOVo3Meta } from "@/src/pages-modules/chapter-manage/chapter-list/Index.vue?macro=true";
import { default as IndexLeKiYirwFjMeta } from "@/src/pages-modules/chapter-manage/chapter-years/Index.vue?macro=true";
import { default as Index0YgNkF6GhFMeta } from "@/src/pages-modules/chapter-manage/chapter-imitate/Index.vue?macro=true";
import { default as IndexbrYiLBZ6vAMeta } from "@/src/pages-modules/chapter-manage/chapter-knowledge/Index.vue?macro=true";
import { default as IndexZSNXmTLJefMeta } from "@/src/pages-modules/user-center/answer-record/Index.vue?macro=true";
import { default as IndexH8YCLS5gqJMeta } from "@/src/pages-modules/user-center/collection/Index.vue?macro=true";
import { default as IndexFbNcSRBbD7Meta } from "@/src/pages-modules/user-center/wrong/Index.vue?macro=true";
import { default as IndexRXjpkUg5GxMeta } from "@/src/pages-modules/user-center/correction/Index.vue?macro=true";
import { default as AppSubjectuYkDglIQnZMeta } from "@/src/pages-modules/user-center/user-select-subject/mobile/AppSubject.vue?macro=true";
import { default as IndexPTwF1DfD4kMeta } from "@/src/pages-modules/user-center/Index.vue?macro=true";
import { default as IndexEvJq0sd4vUMeta } from "@/src/pages-modules/exam/exam-detail/Index.vue?macro=true";
import { default as IndexnNEUPltpwyMeta } from "@/src/pages-modules/exam/exam-answer/Index.vue?macro=true";
import { default as IndexDjfvpSIrGgMeta } from "@/src/pages-modules/exam/exam-result/Index.vue?macro=true";
import { default as IndexmaprhbetZQMeta } from "@/src/pages-modules/exam/exam-analyze/Index.vue?macro=true";
import { default as IndexMyOGWoauNvMeta } from "@/src/pages-modules/exam/exam-review/Index.vue?macro=true";
export default [
  {
    name: IndexDViMv2jZ4dMeta?.name ?? "home",
    path: IndexDViMv2jZ4dMeta?.path ?? "/",
    meta: IndexDViMv2jZ4dMeta || {},
    alias: IndexDViMv2jZ4dMeta?.alias || [],
    redirect: IndexDViMv2jZ4dMeta?.redirect,
    component: () => import("@/src/pages-modules/home/Index.vue").then(m => m.default || m)
  },
  {
    name: MaterialMineve4zHWmyYUMeta?.name ?? "material-mine",
    path: MaterialMineve4zHWmyYUMeta?.path ?? "/material-manage/mine",
    meta: MaterialMineve4zHWmyYUMeta || {},
    alias: MaterialMineve4zHWmyYUMeta?.alias || [],
    redirect: MaterialMineve4zHWmyYUMeta?.redirect,
    component: () => import("@/src/pages-modules/material-manage/MaterialMine.vue").then(m => m.default || m)
  },
  {
    name: MaterialListAa1mVeYpOUMeta?.name ?? "material-list-root",
    path: MaterialListAa1mVeYpOUMeta?.path ?? "/material-manage/list/sub-:subjectId(\\d+)?",
    meta: MaterialListAa1mVeYpOUMeta || {},
    alias: MaterialListAa1mVeYpOUMeta?.alias || [],
    redirect: MaterialListAa1mVeYpOUMeta?.redirect,
    component: () => import("@/src/pages-modules/material-manage/MaterialList.vue").then(m => m.default || m)
  },
  {
    name: MaterialListAa1mVeYpOUMeta?.name ?? "material-list",
    path: MaterialListAa1mVeYpOUMeta?.path ?? "/material-manage/list",
    meta: MaterialListAa1mVeYpOUMeta || {},
    alias: MaterialListAa1mVeYpOUMeta?.alias || [],
    redirect: MaterialListAa1mVeYpOUMeta?.redirect,
    component: () => import("@/src/pages-modules/material-manage/MaterialList.vue").then(m => m.default || m)
  },
  {
    name: IndexZcHpkFOVo3Meta?.name ?? "chapter-list-root",
    path: IndexZcHpkFOVo3Meta?.path ?? "/chapter-manage/list/sub-:subjectId(\\d+)?",
    meta: IndexZcHpkFOVo3Meta || {},
    alias: IndexZcHpkFOVo3Meta?.alias || [],
    redirect: IndexZcHpkFOVo3Meta?.redirect,
    component: () => import("@/src/pages-modules/chapter-manage/chapter-list/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexZcHpkFOVo3Meta?.name ?? "chapter-list",
    path: IndexZcHpkFOVo3Meta?.path ?? "/chapter-manage/list",
    meta: IndexZcHpkFOVo3Meta || {},
    alias: IndexZcHpkFOVo3Meta?.alias || [],
    redirect: IndexZcHpkFOVo3Meta?.redirect,
    component: () => import("@/src/pages-modules/chapter-manage/chapter-list/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexLeKiYirwFjMeta?.name ?? "chapter-years-root",
    path: IndexLeKiYirwFjMeta?.path ?? "/chapter-manage/years/sub-:subjectId(\\d+)?",
    meta: IndexLeKiYirwFjMeta || {},
    alias: IndexLeKiYirwFjMeta?.alias || [],
    redirect: IndexLeKiYirwFjMeta?.redirect,
    component: () => import("@/src/pages-modules/chapter-manage/chapter-years/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexLeKiYirwFjMeta?.name ?? "chapter-years",
    path: IndexLeKiYirwFjMeta?.path ?? "/chapter-manage/years",
    meta: IndexLeKiYirwFjMeta || {},
    alias: IndexLeKiYirwFjMeta?.alias || [],
    redirect: IndexLeKiYirwFjMeta?.redirect,
    component: () => import("@/src/pages-modules/chapter-manage/chapter-years/Index.vue").then(m => m.default || m)
  },
  {
    name: Index0YgNkF6GhFMeta?.name ?? "chapter-imitate-root",
    path: Index0YgNkF6GhFMeta?.path ?? "/chapter-manage/imitate/sub-:subjectId(\\d+)?",
    meta: Index0YgNkF6GhFMeta || {},
    alias: Index0YgNkF6GhFMeta?.alias || [],
    redirect: Index0YgNkF6GhFMeta?.redirect,
    component: () => import("@/src/pages-modules/chapter-manage/chapter-imitate/Index.vue").then(m => m.default || m)
  },
  {
    name: Index0YgNkF6GhFMeta?.name ?? "chapter-imitate",
    path: Index0YgNkF6GhFMeta?.path ?? "/chapter-manage/imitate",
    meta: Index0YgNkF6GhFMeta || {},
    alias: Index0YgNkF6GhFMeta?.alias || [],
    redirect: Index0YgNkF6GhFMeta?.redirect,
    component: () => import("@/src/pages-modules/chapter-manage/chapter-imitate/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexbrYiLBZ6vAMeta?.name ?? "chapter-knowledge-root",
    path: IndexbrYiLBZ6vAMeta?.path ?? "/chapter-manage/knowledge/sub-:subjectId(\\d+)?",
    meta: IndexbrYiLBZ6vAMeta || {},
    alias: IndexbrYiLBZ6vAMeta?.alias || [],
    redirect: IndexbrYiLBZ6vAMeta?.redirect,
    component: () => import("@/src/pages-modules/chapter-manage/chapter-knowledge/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexbrYiLBZ6vAMeta?.name ?? "chapter-knowledge",
    path: IndexbrYiLBZ6vAMeta?.path ?? "/chapter-manage/knowledge",
    meta: IndexbrYiLBZ6vAMeta || {},
    alias: IndexbrYiLBZ6vAMeta?.alias || [],
    redirect: IndexbrYiLBZ6vAMeta?.redirect,
    component: () => import("@/src/pages-modules/chapter-manage/chapter-knowledge/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexPTwF1DfD4kMeta?.name ?? "user-center",
    path: IndexPTwF1DfD4kMeta?.path ?? "/user-center",
    meta: IndexPTwF1DfD4kMeta || {},
    alias: IndexPTwF1DfD4kMeta?.alias || [],
    redirect: IndexPTwF1DfD4kMeta?.redirect,
    component: () => import("@/src/pages-modules/user-center/Index.vue").then(m => m.default || m),
    children: [
  {
    name: IndexZSNXmTLJefMeta?.name ?? "user-answer-record",
    path: IndexZSNXmTLJefMeta?.path ?? "record",
    meta: { ...(IndexZSNXmTLJefMeta || {}), ...{"showTheme":true} },
    alias: IndexZSNXmTLJefMeta?.alias || [],
    redirect: IndexZSNXmTLJefMeta?.redirect,
    component: () => import("@/src/pages-modules/user-center/answer-record/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexH8YCLS5gqJMeta?.name ?? "user-collection",
    path: IndexH8YCLS5gqJMeta?.path ?? "collection",
    meta: { ...(IndexH8YCLS5gqJMeta || {}), ...{"showTheme":true} },
    alias: IndexH8YCLS5gqJMeta?.alias || [],
    redirect: IndexH8YCLS5gqJMeta?.redirect,
    component: () => import("@/src/pages-modules/user-center/collection/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexFbNcSRBbD7Meta?.name ?? "user-wrong",
    path: IndexFbNcSRBbD7Meta?.path ?? "wrong",
    meta: { ...(IndexFbNcSRBbD7Meta || {}), ...{"showTheme":true} },
    alias: IndexFbNcSRBbD7Meta?.alias || [],
    redirect: IndexFbNcSRBbD7Meta?.redirect,
    component: () => import("@/src/pages-modules/user-center/wrong/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexRXjpkUg5GxMeta?.name ?? "user-correction",
    path: IndexRXjpkUg5GxMeta?.path ?? "correction",
    meta: IndexRXjpkUg5GxMeta || {},
    alias: IndexRXjpkUg5GxMeta?.alias || [],
    redirect: IndexRXjpkUg5GxMeta?.redirect,
    component: () => import("@/src/pages-modules/user-center/correction/Index.vue").then(m => m.default || m)
  },
  {
    name: AppSubjectuYkDglIQnZMeta?.name ?? "user-app-subject-name",
    path: AppSubjectuYkDglIQnZMeta?.path ?? "app-subject",
    meta: { ...(AppSubjectuYkDglIQnZMeta || {}), ...{"showTheme":true} },
    alias: AppSubjectuYkDglIQnZMeta?.alias || [],
    redirect: AppSubjectuYkDglIQnZMeta?.redirect,
    component: () => import("@/src/pages-modules/user-center/user-select-subject/mobile/AppSubject.vue").then(m => m.default || m)
  }
]
  },
  {
    name: IndexEvJq0sd4vUMeta?.name ?? "normal-exam-detail",
    path: IndexEvJq0sd4vUMeta?.path ?? "/normal-exam/detail/:id(\\d+).html",
    meta: { ...(IndexEvJq0sd4vUMeta || {}), ...{"detailPageMode":3} },
    alias: IndexEvJq0sd4vUMeta?.alias || [],
    redirect: IndexEvJq0sd4vUMeta?.redirect,
    component: () => import("@/src/pages-modules/exam/exam-detail/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexEvJq0sd4vUMeta?.name ?? "imitate-exam-detail",
    path: IndexEvJq0sd4vUMeta?.path ?? "/imitate-exam/detail/:id(\\d+).html",
    meta: { ...(IndexEvJq0sd4vUMeta || {}), ...{"detailPageMode":4} },
    alias: IndexEvJq0sd4vUMeta?.alias || [],
    redirect: IndexEvJq0sd4vUMeta?.redirect,
    component: () => import("@/src/pages-modules/exam/exam-detail/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexEvJq0sd4vUMeta?.name ?? "previous-exam-detail",
    path: IndexEvJq0sd4vUMeta?.path ?? "/previous-exam/detail/:id(\\d+).html",
    meta: { ...(IndexEvJq0sd4vUMeta || {}), ...{"detailPageMode":5} },
    alias: IndexEvJq0sd4vUMeta?.alias || [],
    redirect: IndexEvJq0sd4vUMeta?.redirect,
    component: () => import("@/src/pages-modules/exam/exam-detail/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexnNEUPltpwyMeta?.name ?? "exam-answer",
    path: IndexnNEUPltpwyMeta?.path ?? "/exam/answer/em-:examMode(\\d+)/:id(\\d+)?",
    meta: { ...(IndexnNEUPltpwyMeta || {}), ...{"hideFooter":true,"showTheme":true} },
    alias: IndexnNEUPltpwyMeta?.alias || [],
    redirect: IndexnNEUPltpwyMeta?.redirect,
    component: () => import("@/src/pages-modules/exam/exam-answer/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexDjfvpSIrGgMeta?.name ?? "exam-result",
    path: IndexDjfvpSIrGgMeta?.path ?? "/exam/result/em-:examMode(\\d+)/:id(\\d+)?",
    meta: IndexDjfvpSIrGgMeta || {},
    alias: IndexDjfvpSIrGgMeta?.alias || [],
    redirect: IndexDjfvpSIrGgMeta?.redirect,
    component: () => import("@/src/pages-modules/exam/exam-result/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexmaprhbetZQMeta?.name ?? "exam-analyze",
    path: IndexmaprhbetZQMeta?.path ?? "/exam/analyze/em-:examMode(\\d+)/:id(\\d+)?",
    meta: { ...(IndexmaprhbetZQMeta || {}), ...{"hideFooter":true} },
    alias: IndexmaprhbetZQMeta?.alias || [],
    redirect: IndexmaprhbetZQMeta?.redirect,
    component: () => import("@/src/pages-modules/exam/exam-analyze/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexMyOGWoauNvMeta?.name ?? "exam-review",
    path: IndexMyOGWoauNvMeta?.path ?? "/exam/review/:id(\\d+)",
    meta: { ...(IndexMyOGWoauNvMeta || {}), ...{"hideFooter":true} },
    alias: IndexMyOGWoauNvMeta?.alias || [],
    redirect: IndexMyOGWoauNvMeta?.redirect,
    component: () => import("@/src/pages-modules/exam/exam-review/Index.vue").then(m => m.default || m)
  }
]